import styled from 'styled-components';
import { mediaQuery } from '../../common/styles/styleUtil';

export const PropertyTypeTabItemWrapper = styled.a`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (${mediaQuery.mobile}) {
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  opacity: 0.9;
  &:hover {
    opacity: 1;
    span {
      text-decoration: underline;
    }
  }

  img {
    width: 100%;
    border-radius: 3px;
    height: 72px;
  }

  span {
    position: absolute;
    color: #ffffff;
    font-size: 20px;
    font-weight: 400;
  }
`;
